/**
 * @generated SignedSource<<2a1ba3beff1078143c41bf95787759e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendMarketingEmailTestEmailDialogFindContactQuery$variables = {
  searchTerm: string;
};
export type SendMarketingEmailTestEmailDialogFindContactQuery$data = {
  readonly contacts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly emailAddress: string | null | undefined;
        readonly familyName?: string;
        readonly givenName?: string;
        readonly id: string;
        readonly teamName?: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SendMarketingEmailTestEmailDialogFindContactQuery = {
  response: SendMarketingEmailTestEmailDialogFindContactQuery$data;
  variables: SendMarketingEmailTestEmailDialogFindContactQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      },
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      }
    ],
    "concreteType": "CustomerAccountContactConnection",
    "kind": "LinkedField",
    "name": "contacts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerAccountContactEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "teamName",
                    "storageKey": null
                  }
                ],
                "type": "TeamContact",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "givenName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "familyName",
                    "storageKey": null
                  }
                ],
                "type": "PersonContact",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendMarketingEmailTestEmailDialogFindContactQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendMarketingEmailTestEmailDialogFindContactQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ae811e98a93775cbc112585a889a969",
    "id": null,
    "metadata": {},
    "name": "SendMarketingEmailTestEmailDialogFindContactQuery",
    "operationKind": "query",
    "text": "query SendMarketingEmailTestEmailDialogFindContactQuery(\n  $searchTerm: String!\n) {\n  contacts(searchTerm: $searchTerm, first: 1) {\n    edges {\n      node {\n        __typename\n        id\n        ... on TeamContact {\n          teamName\n        }\n        ... on PersonContact {\n          givenName\n          familyName\n        }\n        emailAddress\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a3781bb8bf0425d56d3dda256d64acb9";

export default node;
